<template>
    <section v-if="$role.restricAccess($route.name, 'view')">
        <breadcrumb-template :headtitle="$route.meta.title" :breadcrumbcurrent="$route.meta.title"></breadcrumb-template>
        <v-card class="card-outline">
            <v-card-text>
                <v-container fluid>
                    <v-row dense class="mb-5 text-center text-md-left subtitle-1">
                        <v-col cols="12" lg="4">
                            <strong>Total payout: <v-avatar :size="$gold_coin_sm"><img src="images/Gold-Coin-50x50.png" alt="coin"></v-avatar> {{ dt_total_winnerprize | toNumberWithDecimal }}</strong>
                        </v-col>
                    </v-row>
                    <v-row dense class="d-flex justify-end mt-n2">
                        <v-col cols="12" md="6" lg="5" xl="2"></v-col>
                        <!-- <v-col cols="12" md="6" lg="5" xl="2"></v-col> -->
                        
                        <v-col cols="12" md="6" lg="5" xl="2">
                            <agent-credit-autocomplete-template ref="agent_autocomplete"></agent-credit-autocomplete-template>
                        </v-col>

                        <v-col cols="12" md="6" lg="5" xl="2" :class="($vuetify.breakpoint.mobile) ? 'mb-6':''">
                            <player-autocomplete-template ref="player_autocomplete"></player-autocomplete-template>
                        </v-col>

                        <v-col cols="12" md="6" lg="5" xl="2">
                            <v-select outlined dense clearable :items="['Consolation', 'Winner']" label="Payout type" v-model="filter.payouttype"></v-select>
                        </v-col>

                        <v-col cols="12" md="6" lg="5" xl="2">
                            <v-select outlined dense clearable :items="['Claimed', 'Unclaimed']" label="Status" v-model="filter.status"></v-select>
                        </v-col>

                        <v-col cols="12" md="6" lg="5" xl="2">
                            <v-select outlined dense clearable :items="drawlist" item-value="id" item-text="name" label="Draw" v-model="filter.draw" multiple>
                                <template v-slot:selection="{ item, index }">
                                    <v-chip v-if="index === 0" small>
                                        <span>{{ item.name }}</span>
                                    </v-chip>
                                    <span v-if="index === 1" class="grey--text text-caption">(+{{ filter.draw.length - 1 }})</span>
                                </template>
                            </v-select>
                        </v-col>

                        <v-col cols="12" md="6" lg="5" xl="2">
                            <v-dialog ref="dialog" v-model="filter_datedialog" :return-value.sync="filter.daterange" persistent width="290px">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field outlined dense v-model="filter.daterange" label="Dates" readonly v-bind="attrs" v-on="on" clearable></v-text-field>
                                </template>
                                <v-date-picker v-model="filter.daterange" scrollable range>
                                    <v-spacer></v-spacer>
                                    <v-btn text color="primary" @click="filter_datedialog = false">Cancel</v-btn>
                                    <v-btn text color="primary" @click="$refs.dialog.save(filter.daterange)">OK</v-btn>
                                </v-date-picker>
                            </v-dialog>
                        </v-col>

                        <v-col cols="12" md="6" lg="5" xl="2">
                            <v-text-field clearable dense outlined v-model="dt_searchQuery" label="Search"></v-text-field>
                        </v-col>

                        <v-col cols="12" md="1" :class="($vuetify.breakpoint.mobile) ? 'mb-2':''">
                            <v-btn color="info" class="float-right btn-block" @click="getDataFromApi()"><v-icon>mdi-magnify</v-icon></v-btn>
                        </v-col>
                        
                        <v-col cols="12" class="mt-2">
                            <v-data-table class="table-bordered table-striped" :headers="dt_headers" :items="dt_resultlist" item-key="id" :loading="dt_loading"  :options.sync="dt_options" :server-items-length="dt_totalResult">
                                
                                <template v-slot:[`item.totalgross`]="{ item }"><v-avatar :size="$gold_coin_sm"><img src="images/Gold-Coin-50x50.png" alt="coin"></v-avatar> {{ (item.totalgross == null) ? 0.00 : item.totalgross | toNumberWithDecimal }}</template>

                                 <template v-slot:[`item.totalwinshare`]="{ item }"><v-avatar :size="$gold_coin_sm"><img src="images/Gold-Coin-50x50.png" alt="coin"></v-avatar> {{ (item.totalwinshare == null) ? 0.00 : item.totalwinshare | toNumberWithDecimal }}</template>

                                <template v-slot:[`item.winningprize`]="{ item }"><v-avatar :size="$gold_coin_sm"><img src="images/Gold-Coin-50x50.png" alt="coin"></v-avatar> {{ (item.winningprize == null) ? 0.00 : item.winningprize | toNumberWithDecimal }}</template>

                                <template v-slot:[`item.totalcomission`]="{ item }"><v-avatar :size="$gold_coin_sm"><img src="images/Gold-Coin-50x50.png" alt="coin"></v-avatar> {{ (item.totalcomission == null) ? 0.00 : item.totalcomission | toNumberWithDecimal }}</template>

                                <template v-slot:[`item.totalwin`]="{ item }"><v-avatar :size="$gold_coin_sm"><img src="images/Gold-Coin-50x50.png" alt="coin"></v-avatar> {{ (item.totalwin == null) ? 0.00 : item.totalwin | toNumberWithDecimal }}</template>

                                 <template v-slot:[`item.totalpayout`]="{ item }"><v-avatar :size="$gold_coin_sm"><img src="images/Gold-Coin-50x50.png" alt="coin"></v-avatar> {{ payout(item.totalpayout,item.totalwin,item.totalcomission,item.winningprize,item.totalwinshare ) |  toNumberWithDecimal}}</template>


                                <template v-slot:[`item.claimed`]="{ item }">
                                    <!-- <div v-if="item.claimed == 'Unclaimed'"> -->
                                        <v-btn-toggle block rounded v-if="item.claimed == 'Unclaimed'">
                                            <v-btn color="warning" dark small :loading="isLoadingBtn" @click="claim(item)">{{ item.claimed }}</v-btn>
                                        </v-btn-toggle>
                                        <div v-else>{{ item.claimed }}</div>
                                    <!-- </div> -->
                                </template>

                                <template v-slot:[`item.actions`] v-if="$role.restricAccess($route.name, 'edit')">
                                    <v-btn-toggle block rounded>
                                        <v-btn color="info" dark small><v-icon>mdi-pencil</v-icon></v-btn>
                                        <v-btn color="error" dark small><v-icon>mdi-delete</v-icon></v-btn>
                                    </v-btn-toggle>
                                </template>

                            </v-data-table>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
        </v-card>

        <confirm-dialog ref="confirm"></confirm-dialog>

    </section>
</template>

<script>
    export default {
        data(){
            return{
                dialogForm: false,
                isLoadingBtn: false,
                isLoadingBtnDelete: false,
                formerror: {},
                modalUpdate: false,
                dt_headers: [
                    { text: 'Master agent/sub-agent', value: 'agent_name', name: 'agent_name', sortable: false, searchable: true},
                    { text: 'Gross', value: 'totalgross', name: 'totalgross', sortable: false, searchable: true},
                    { text: 'WS', value: 'totalwinshare', name: 'totalwinshare', sortable: false, searchable: true},
                    { text: 'Comi', value: 'totalcomission', name: 'totalcomission', sortable: false, searchable: false},
                    { text: 'Win', value: 'totalwin', name: 'totalwin', sortable: false, searchable: true},
                    { text: 'Payout', value: 'totalpayout', name: 'totalpayout', sortable: false, searchable: true},
                ],
                dt_options: {},
                dt_columns:{},
                dt_totalResult: 0,
                dt_searchInput: '',
                dt_searchQuery: "",
                dt_resultlist: [],
                dt_loading: true,
                dt_itemsPerPage: 50,
                dt_reload: '',
                dt_total_winnerprize: '',
                form: new this.$Form({
                    id: '',
                    name: '',
                    username: '',
                    email: '',
                    password: '',
                    roles: {},
                    user_status: 1,
                }),
                filter: {
                    datefrom: null,
                    dateto: null,
                    draw: [],
                    daterange: null,
                    status: null,
                    payouttype: null,
                },
                drawlist: [],
                filter_datedialog: null,
            };
        },
        methods:{
          
            paramsfilter(){
                let from, to, agent_id, player = '';

                if(this.filter.daterange){
                    from = this.$moment(this.filter.daterange[0]).format('MM-DD-YYYY');
                    to = this.$moment(this.filter.daterange[1]).format('MM-DD-YYYY');
                }

                if(this.$refs.agent_autocomplete){
                    agent_id = (this.$refs.agent_autocomplete.autocomplete_model != undefined) ? this.$refs.agent_autocomplete.autocomplete_model.id : 0;
                }

                if(this.$refs.player_autocomplete){
                    player = (this.$refs.player_autocomplete.autocomplete_model != undefined) ? this.$refs.player_autocomplete.autocomplete_model.id : 0;
                }

                return {
                    ...this.dt_options,
                    query: this.dt_searchQuery,
                    date: this.filter.date,
                    reload: this.dt_reload,
                    status: this.filter.status,
                    draw: this.filter.draw.join(','),
                    from: from,
                    to: to,
                    payouttype: this.filter.payouttype,
                    agent_id: agent_id,
                    player: player,
                };
            },
            async getDataFromApi() {
                this.dt_loading = true;
                var paramsfilter = await this.paramsfilter();
                this.dt_columns = await this.$YajraDT.setHeader(this.dt_headers);
                let params = await this.$YajraDT.params(paramsfilter, this.dt_options, this.dt_itemsPerPage, this.dt_columns);
                let apiPath = await this.$_CONFIG.api('API_AGENTWINSUMMARY');

                await this.$axios.get(apiPath + "?" + this.$.param(params)).then((res) => {
                    if(this.dt_totalResult != res.data.recordsFiltered){ this.dt_options.page = 1; }

                    this.dt_resultlist = res.data.data;
                    this.dt_totalResult = res.data.recordsFiltered;
                    this.dt_total_winnerprize = res.data.totalWinningPrize;
                    this.dt_loading = false;
                }).catch((err) => {
                    this.dt_loading = false;
                    console.log("Error searching");
                });

                var unwatch = this.$watch('dt_options.page', function(newValue, oldValue) {
                    this.getDataFromApi();
                    unwatch();
                }, { deep: true });
            },
            getdrawlist(){
                this.$axios.get( this.$_CONFIG.api('API_DRAW_DROPDOWN'))
                .then(res => {
                    this.drawlist = res.data;
                })
                .catch(err => {
                    console.log(err)
                });
            },
            payout(totalpayout,totalwin,totalcomission,winningprize,totalwinshare){
                let sum = totalwin + totalcomission + totalwinshare;
                return totalpayout - sum;
              
            }
        },
        
        created(){
            this.getdrawlist();
            this.getDataFromApi();
        },
        mounted() {
        }
    }
</script>
<style scoped>

</style>
